import { Alert, Box } from "@mui/material";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { Resources, useResource } from "Translations/Resources";
import type { PropsWithChildren } from "react";

/**
 * Renders its children only once user-info is loaded: an error alert when the query failed, a
 * spinner while it loads. Pages whose content depends on the person's state (the Stardust consent,
 * ZS-1624, read through useHasStardustConsent) use it so the content never flashes before the
 * state is known.
 */
export const UserInfoGate = ({ children }: PropsWithChildren) => {
  const { t } = useResource();
  const { data: userInfo, isError } = useUserInfoQuery();

  if (isError) {
    return (
      <Box p={3}>
        <Alert severity="error">{t(Resources.Error.SomethingWentWrong)}</Alert>
      </Box>
    );
  }

  if (!userInfo) {
    return <CenteredCircularProgress />;
  }

  return <>{children}</>;
};
